<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nAa7wq/tc-custom/9781634868273.jpg?1723406323991" alt="This image is the cover for the book Family Bonds, Crypt Coffee"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Family Bonds, Crypt Coffee
      </h1>
      <p class="bookDescription body article font2">
        <p>Sequel to <i>Night Terror</i><br/><br/>It’s January and Professor Sean Sanderson has a little time off, though it’s anything but relaxing. Between a Guild initiation and a birthday, he’s stressed, and that’s before he and Dane, his Decrypter boyfriend, learn a werewolf has been murdered. The local Packs are at each other’s throats about the death and don’t want either Sean or Dane getting involved, which they’d be glad to do ... if the werewolf in question hadn’t reappeared as a violent ghost.<br/><br/>Just when they have their hands full trying to dodge around Pack politics and track down a werewolf ghost before he hurts anyone, Dane’s parents show up at his coffee shop. They have no idea their son is a Decrypter, and they have no intention of leaving until they spend some quality family time together.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gareth Vaughn
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b127988